import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Contracts from '../../../../api/api-contracts';
import { BlockDayProcessedModal } from '../../app-bookings-messages/block-day-processed-modal';
import { OpHoursNotificationModal } from '../../app-bookings-messages/OpHoursNotificationModal';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { FormBuilder } from 'shared-components/forms/form';
import { RadioGroup } from '../../elements-inputs/radio-group';
import { LightbulbTip } from '../../app-host-calendar/shared-component/lightbulb-tip';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

const declineReasons = {
  space_not_available: 'The space is not available at that time',
  incorrect_price: 'The price of the request is incorrect',
  minimum_hours: 'This request does not meet our minimum number of hours',
  too_many_people: 'The space can\'t hold that many people',
  outside_op_hours: 'This request is outside our operating hours',
  not_a_fit: 'This activity doesn\'t fit with our space',
  other: 'Other'
};

class DeclineBkgRequestModal extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      errorText: '',
      isProcessing: false
    };

    this.modalBody = this.modalBody.bind(this);
    this.declineRequest = this.declineRequest.bind(this);
    this.declineRequestCb = this.declineRequestCb.bind(this);
    this.customOfferLink = this.customOfferLink.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount () {
    const { iosWebView, scrollTopIOS } = this.props;
    if (iosWebView) {
      scrollTopIOS();
    }
  }

  customOfferLink (subject) {
    const { bookingId, createCustomOffer, iosWebView } = this.props;
    let customOfferLink = <a href={`/inbox/${bookingId}/offer-custom-price`}>
      <FormattedMessage
        id="inbox.decline_bkg_request_modal.custom"
        defaultMessage="custom offer"
      />
    </a>;
    if (iosWebView) {
      customOfferLink = <span className="link-span" onClick={createCustomOffer}>
        <FormattedMessage
          id="inbox.decline_bkg_request_modal.custom_ios"
          defaultMessage="custom offer"
        />
      </span>;
    }
    return (
      <LightbulbTip
        description={
          <span className="text-gray-dark">
            <FormattedMessage
              id="inbox.decline_bkg_request_modal.adjust"
              defaultMessage="Adjust the {subject} by sending a"
              values={{
                subject: subject
              }}
            />&nbsp;
            { customOfferLink }
          </span>
        }
      />
    );
  }

  declineRequest (form, cb, refs) {
    this.setState({ isProcessing: true });

    const { bookingId } = this.props;
    const value = refs.radio
      ? refs.radio.returnRadioGroupValue()
      : $('#booking_cancel_reason').val();

    const existingReason = declineReasons.hasOwnProperty(value);
    const payload = {
      reason: existingReason ? declineReasons[value] : value,
      canonical_reason: existingReason ? value : 'other'
    };

    Contracts.updateRequest(payload, bookingId, PSSessions.Cookies('PSAccess'), 'decline', (response) => {
      cb(response, value, refs.radio.returnRadioValueId());
    });
  }

  declineRequestCb (resp, value, valueId) {
    if (200 !== resp.statusCode) {
      return this.setState({
        errorText: this.props.intl.formatMessage({ id: 'inbox.decline_bkg_request_modal.error', defaultMessage: 'An error occurred. Please refresh the page and try again.' })
      });
    }

     const { iosWebView, closeIOSModal, finalCb, redirectToInboxDetails } = this.props;
    if (iosWebView) {
      closeIOSModal();
      return finalCb();
    }
    const bookingId = _.get(resp, 'control_id', '');
    const spaceRentalContract = _.find(_.get(resp, 'contracts', []), { type: 'SPACE_RENTAL' });
    const spaceId = _.get(spaceRentalContract, 'meta.booking.space_id', '');

    const riskObj = _.get(spaceRentalContract, 'meta.risk', {});
    riskObj.warningType = riskObj.alcohol_consumed && riskObj.is_late_night
      ? 'alcoholAndLateNight'
      : riskObj.alcohol_consumed
      ? 'alcohol'
      : 'lateNight';

    const showTSWarning = riskObj?.host_social_events_policy_agreement_required;
    analyticsIntegrations.bookingRequestDeclined(_.get(resp, 'contracts', []), value, 'other' === valueId, showTSWarning ? riskObj : {});

    if ('space_not_available' === value && !iosWebView) {
      ReactDOM.render(
        <SharedIntlProviderHOC>
          <BlockDayProcessedModal
            booking={this.props.booking}
            onClose={this.closeCalendarModal}
            intl={this.props.intl}
          />
        </SharedIntlProviderHOC>, document.getElementById('modal-container')
      );
    } else if ('outside_op_hours' === value && !iosWebView) {
      ReactDOM.render(
        <SharedIntlProviderHOC>
          <OpHoursNotificationModal
            onClose={this.closeCalendarModal}
            reason={value}
            bookingId={bookingId}
            spaceId={spaceId}
          />
        </SharedIntlProviderHOC>, document.getElementById('modal-container')
      );
    }

    redirectToInboxDetails();
  }

  closeModal () {
    this.props.toggleModal('');
  }

  closeCalendarModal () {
    ReactDOM.unmountComponentAtNode(document.getElementById('modal-container'));
    $('#modal-container').modal('hide');
  }

  modalBody () {
    const { isProcessing } = this.state;
    return (
      <div className="decline-offer-modal col-xs-12" style={{ paddingBottom: 40 }}>
        <p className="gutter">
          <FormattedMessage
            id="inbox.decline_bkg_request_modal.tell_quest"
            defaultMessage="Tell your guest why you are declining their booking request."
          />
        </p>
        <FormBuilder
          formname="decline-request-form"
          formStyle="modal-plus gutter margin-lg-left"
          formInputs={[{ custom: () => {
            return (<RadioGroup
              isRequired
              ref="radio"
              inputData={[
                {
                  ID: 'booked',
                  value: 'space_not_available',
                  displayText: this.props.intl.formatMessage({ id: 'inbox.decline_bkg_request_modal.not_available_text', defaultMessage: 'The space is not available at that time' })
                },
                {
                  ID: 'price',
                  value: 'incorrect_price',
                  displayText: this.props.intl.formatMessage({ id: 'inbox.decline_bkg_request_modal.price_incorrect_text', defaultMessage: 'The price of the request is incorrect' }),
                  addtlText: this.customOfferLink(this.props.intl.formatMessage({ id: 'inbox.decline_bkg_request_modal.price', defaultMessage: 'price' }))
                },
                {
                  ID: 'hours',
                  value: 'minimum_hours',
                  displayText: this.props.intl.formatMessage({ id: 'inbox.decline_bkg_request_modal.request_not_meet_text', defaultMessage: 'This request does not meet our minimum number of hours' }),
                  addtlText: this.customOfferLink(this.props.intl.formatMessage({ id: 'inbox.decline_bkg_request_modal.hours', defaultMessage: 'hours' }))
                },
                {
                  ID: 'guest-number',
                  value: 'too_many_people',
                  displayText: this.props.intl.formatMessage({ id: 'inbox.decline_bkg_request_modal.cant_hold_text', defaultMessage: "The space can't hold that many people" }),
                  addtlText: this.customOfferLink(this.props.intl.formatMessage({ id: 'inbox.decline_bkg_request_modal.number_of_guests', defaultMessage: 'number of guests' }))
                },
                {
                  ID: 'timing',
                  value: 'outside_op_hours',
                  displayText: this.props.intl.formatMessage({ id: 'inbox.decline_bkg_request_modal.request_outside_text', defaultMessage: 'This request is outside our operating hours' })
                },
                {
                  ID: 'activity',
                  value: 'not_a_fit',
                  displayText: this.props.intl.formatMessage({ id: 'inbox.decline_bkg_request_modal.not_fit_text', defaultMessage: "This activity doesn't fit with our space" })
                },
                {
                  ID: 'other',
                  value: 'other',
                  displayText: this.props.intl.formatMessage({ id: 'inbox.decline_bkg_request_modal.other', defaultMessage: 'Other' }),
                  collectUserInput: true
                }
              ]}
              groupName="decline-reason"
            />);
          } }]}
          submitAction={ this.declineRequest }
          submitCallback={ this.declineRequestCb }
          isButtonDisabled={ isProcessing }
          isDisableSpinning={ false }
          buttonText={ this.props.intl.formatMessage({ id: 'inbox.decline_bkg_request_modal.decline_modal', defaultMessage: 'Decline booking' }) }
          closeOption={ this.props.intl.formatMessage({ id: 'inbox.decline_bkg_request_modal.cancel_modal', defaultMessage: 'Cancel' }) }
          errorText={ this.state.errorText }
        />
      </div>
    );
  }

  render () {
    const { iosWebView } = this.props;
    return (
      <div>
        {
          iosWebView ?
            <div id="decline-request-modal" className="decline-request-modal-ios">
              <button className="btn-link remove-click-styling pull-right ico ico-sm icon-close-sidebar" onClick={this.closeModal} />
              <div className="text-center">
                <h4>
                  <FormattedMessage
                    id="inbox.decline_bkg_request_modal.decline_booking"
                    defaultMessage="Decline booking"
                  />
                </h4>
              </div>
              {
                this.modalBody()
              }
            </div>
            :
            <BootstrapModal
              {...this.props}
              addCloseIcon
              show
              modalID="decline-update-modal"
              modalSize="sm-size"
              modalType="standard"
              header={ <h4><FormattedMessage id="inbox.decline_bkg_request_modal.decline_modal" defaultMessage="Decline booking" /></h4> }
              body={ this.modalBody() }
            />
        }
      </div>
    );
  }
}


DeclineBkgRequestModal.propTypes = {
  bookingId: PropTypes.string,
  createCustomOffer: PropTypes.func,
  iosWebView: PropTypes.bool,
  closeIOSModal: PropTypes.func,
  toggleModal: PropTypes.func,
  whichModal: PropTypes.string,
  finalCb: PropTypes.func,
  redirectToInboxDetails: PropTypes.func,
  intl: intlShape
};

DeclineBkgRequestModal.contextTypes = {
  router: PropTypes.object
};

exports.DeclineBkgRequestModal = injectIntl(DeclineBkgRequestModal);
